import React from "react";
import Hero from "../components/Hero";
import AboutUs from "../components/AboutUs";
import FundsRaised from "../components/FundsRaised";
import FeaturedSpotlight from "../components/FeaturedSpotlight";
import ProductGrid from "../components/ProductGrid";
import DonationsCarousel from "../components/DonationsCarousel";
import SubscribeForm from "../components/SubscribeForm";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";
import CartDrawer from "../components/CartDrawer";
import PaymentStatus from "../components/PaymentStatus";

export default function Home() {
  return (
    <div className="App min-h-screen">
      <Hero />
      <AboutUs />
      <FundsRaised />
      <FeaturedSpotlight />
      <ProductGrid />
      <DonationsCarousel />
      <SubscribeForm />
      <ContactForm />
      <Footer />
      <CartDrawer />
      <PaymentStatus />
    </div>
  );
}
